import { z } from "zod";

export type SrcUserTypeResponse = z.infer<typeof SrcUserTypeResponseSchema>;
export const SrcUserTypeResponseSchema = z.object({
  is_sandbox_user: z.boolean().optional(),
  type: z.string().optional(),
});
